module.exports = __webpack_public_path__ + "img/icon-tv.c34afe1a.svg";